import { useEffect, useState } from "react";
import { IMAGES } from "../../../../assets";
import { useInView } from "react-intersection-observer";

const Statistic = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.3, // Trigger when 10% of the image is visible
  });

  return (
    <section className="statistics-section" id="contact">
      <div className="container">
        <figure className="mb-0 statistics-sidelayer">
          <img src={IMAGES.statistics_sidelayer} alt="" />
        </figure>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="statistics_content">
              <h4 className="text-white">Get in Touch Anytime</h4>
              <h2 className="text-white">We’re here for you 24x7</h2>
              <p className="text-white">
                Tap into cosmic insights that guide your path and illuminate your future. Reach out whenever you seek clarity, connection, or cosmic insight.
              </p>
            </div>
          </div>
        </div>
        <div
          ref={ref}
          className={`statistics-value ${inView ? "animate__animated animate__slideInDown" : ""
            }`}
          data-aos="fade-down"
        >
          <div className="contact-main-div row">
            <div className="col-md-4">
              <div className="contac-emergency-div">
                <div>
                  <img src={IMAGES.ion_call} alt="" width={"35px"} />
                </div>
                <div>
                  <p className="" style={{ fontSize: "11px", color: "#862B89", padding: "0px", margin: "0px", lineHeight: "20px" }}>Call Us</p>
                  <a href="tel:+15166155325">
                    <p className="" style={{ fontSize: "17px", color: "#862B89", padding: "0px", margin: "0px", lineHeight: "20px", fontWeight: "700" }}>+1 (516) 615-5325</p>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contac-emergency-div">
                <div>
                  <img src={IMAGES.ic_round_email} alt="" width={"35px"} />
                </div>
                <div>
                  <p className="" style={{ fontSize: "11px", color: "#862B89", padding: "0px", margin: "0px", lineHeight: "20px" }}>Email</p>
                  <a href="mailto:contact@code-infused.com" target="_blank">
                    <p className="" style={{ fontSize: "17px", color: "#862B89", padding: "0px", margin: "0px", lineHeight: "20px", fontWeight: "700" }}>contact@code-infused.com</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistic;
